var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "reviews-average-ratings" },
    [
      _c("div", { staticClass: "h4 mb-1 pb-0" }, [
        _vm._v("\n        " + _vm._s(_vm.subtitle) + "\n    "),
      ]),
      _vm._v(" "),
      _vm._l(_vm.averageRatings, function (averageRating, index) {
        return _c(
          "div",
          { key: index, staticClass: "row align-items-center" },
          [
            _c("p", {
              staticClass: "col-6 d-md-none mb-0 pe-0",
              domProps: { innerHTML: _vm._s(averageRating.label) },
            }),
            _vm._v(" "),
            _c("ob1-rating", {
              staticClass: "col-6 d-md-none ps-0",
              attrs: {
                average: averageRating.value,
                "rating-results-height": 1.25,
                "with-score": true,
              },
            }),
            _vm._v(" "),
            _c("p", {
              staticClass: "col-md-5 d-none d-md-block mb-0 pe-0",
              domProps: { innerHTML: _vm._s(averageRating.label) },
            }),
            _vm._v(" "),
            _c("ob1-rating", {
              staticClass: "col-md-7 d-none d-md-block",
              attrs: {
                average: averageRating.value,
                "rating-results-height": 1.375,
                "with-score": true,
              },
            }),
          ],
          1
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }